/*
 * @Description:
 * @Date: 2021-04-25 09:56:17
 */
import Vue from 'vue';
// render dom to document.body
import store from '@/store/index.js';
import router from '@/router/index';

/**
 *
 * @param Component 组件
 * @param props 组件参数
 * @param target 挂载的dom结点 默认为 document.body
 * @return {*}
 */
function create(Component, props, target) {
  const tar = target || document.body;

  const Ctor = Vue.extend(Component);
  const comp = new Ctor({ propsData: props, store, router });
  comp.$mount();
  const ele = comp.$el;

  tar.appendChild(ele);
  comp.$on('close', () => {
    comp.$destroy();
    try {
      tar.removeChild(ele);
      document.body.removeChild(ele);
    } catch (err) {
      // console.log('');
    }
  });
  comp.$on('remove', () => {
    comp.$destroy();
    try {
      tar.removeChild(ele);
      document.body.removeChild(ele);
    } catch (err) {
      // console.log('');
    }
  });
  comp.remove = () => {
    comp.$destroy();
    try {
      tar.removeChild(ele);
      document.body.removeChild(ele);
    } catch (err) {}
  };
  return comp;
}

export default create;
